import { createSlice } from '@reduxjs/toolkit';

import { HISTORY_RANGE } from './constants';

import { AppState } from '../store';
import { resetHistory, setHistoryRange } from './actions';

export type TOpenOrderCreateTimeMap = {
  [instrumentAddrTickSizeId in string]: number;
};
export interface IGraphState {
  historyRange: HISTORY_RANGE;
}
const initialState: IGraphState = {
  historyRange: HISTORY_RANGE.D_7,
};

export const graphSlice = createSlice({
  name: 'graph',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(resetHistory, (state, {}) => {
      state.historyRange = HISTORY_RANGE.D_7;
    });
    builder.addCase(setHistoryRange, (state, { payload }) => {
      state.historyRange = payload;
    });
  },
});

export const selectGraphState = (state: AppState): IGraphState => state.graph;

export const selectHistoryRange = (state: AppState): HISTORY_RANGE => state.graph.historyRange;

export default graphSlice.reducer;
